module.exports = __webpack_public_path__ + "static/img/118.7c77e17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/118.png
// module id = mS4/
// module chunks = 0